import React from 'react';
import { Controller } from 'react-hook-form';
import {
  FormControl,
  FormLabel,
  Typography,
} from '@mui/material';
import { StandardFieldProps } from './FieldTypes';
import FormattedTextEditor from '../clientAI/FormattedTextEditor';

const StandardFormattedTextField = ({
  control,
  fieldName,
  field,
  readOnly,
}: StandardFieldProps) => (
  <Controller
    name={fieldName}
    control={control}
    render={({ field: { onChange, value } }) => (
      <FormControl fullWidth id={fieldName}>
        <FormLabel htmlFor={fieldName}>
          <Typography color="inherit" fontWeight="inherit" component="div">
            {field.label}
          </Typography>
        </FormLabel>
        <FormattedTextEditor
          value={typeof value === 'string' ? value : (value?.html || '<p></p>')}
          onChange={(next) => onChange(next.html)}
          controls={field.controls}
          minHeight={field.rows ? Math.max(field.rows * 20, 96) : 96}
          readOnly={Boolean(readOnly)}
        />
      </FormControl>
    )}
  />
);

export default StandardFormattedTextField;
